var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreshteamGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_13023",
    "data-name": "Group 13023",
    transform: "translate(-80 -177)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2503",
    "data-name": "Rectangle 2503",
    width: 40,
    height: 40,
    rx: 4,
    transform: "translate(80 177)",
    fill: "#6a6a6a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freshteam-logo-vector",
    transform: "translate(218.8 -47.1)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12948",
    "data-name": "Path 12948",
    d: "M-118.8,257.1a13,13,0,0,1-13-13,13,13,0,0,1,13-13h9.744a3.265,3.265,0,0,1,3.256,3.256v9.768a13,13,0,0,1-13,12.976",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12949",
    "data-name": "Path 12949",
    d: "M-95.374,270.624a6.472,6.472,0,0,0,5.626-3.256,6.509,6.509,0,0,0-5.626-3.232A6.472,6.472,0,0,0-101,267.393a6.509,6.509,0,0,0,5.626,3.232m2.538-10.454a2.567,2.567,0,0,1-2.562,2.571,2.567,2.567,0,0,1-2.562-2.571A2.567,2.567,0,0,1-95.4,257.6a2.567,2.567,0,0,1,2.562,2.571",
    transform: "translate(-23.426 -20.012)",
    fill: "#6a6a6a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreshteamGray);
export default __webpack_public_path__ + "static/media/Freshteam-gray.af60faaa78e09c57496909f9abd20d6a.svg";
export { ForwardRef as ReactComponent };